import { ReactNode } from 'react';

type ErrorLogFilterFieldProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

export default function ErrorLogFilterField({
  label,
  children,
  className = 'w-56'
}: ErrorLogFilterFieldProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <span className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
        {label}
      </span>
      {children}
    </div>
  );
}
